import { render } from "./RagList.vue?vue&type=template&id=647a5339&scoped=true"
import script from "./RagList.vue?vue&type=script&lang=js"
export * from "./RagList.vue?vue&type=script&lang=js"

import "./RagList.vue?vue&type=style&index=0&id=647a5339&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647a5339"]])

export default __exports__